import { useBatchPaymentDetail } from "Api/Queries/Banking/useBatchPaymentDetail";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { BatchPaymentDetailContent } from "Components/BatchPayments/BatchPaymentDetailContent";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import type { ReactNode } from "react";
import { useParams } from "react-router-dom";

const PAGE_RESOURCES = Resources.Pages.Titles;
const BP_RESOURCES = Resources.Banking.BatchPayments;

export const BatchPaymentDetailPage = () => {
  const { t } = useResource();
  const { id } = useParams();
  const { data, isLoading, isError } = useBatchPaymentDetail({
    publicId: id,
  });

  if (isLoading) {
    return (
      <Layout>
        <PrimaryPaper sx={{ height: "350px" }}>
          <CenteredCircularProgress />
        </PrimaryPaper>
      </Layout>
    );
  }

  if (!data || isError || !id) {
    return (
      <Layout>
        <PrimaryPaper>
          <ErrorText>{t(BP_RESOURCES.NotFound)}</ErrorText>
        </PrimaryPaper>
      </Layout>
    );
  }

  return (
    <Layout>
      <PrimaryPaper>
        <BatchPaymentDetailContent data={data} />
      </PrimaryPaper>
    </Layout>
  );
};

export default BatchPaymentDetailPage;

const Layout = ({ children }: { children: ReactNode }) => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(PAGE_RESOURCES.BatchPaymentDetail)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("batch-payments"),
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">{children}</div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};
